$(document).ready(function () {

    function rgbToHex(rgb) {
        if (!rgb) return '';

        let result = rgb.match(/\d+/g);
        if (!result) return '';

        return "#" + result.map(x => {
            let hex = parseInt(x).toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }).join('').toUpperCase();
    }

    function updateText() {

        let texture = $('.texture-button:checked').val();
        let color = $('.colour-button:checked').val();

        texture = texture || '';
        color = color || '';

        $('.specification-texture-color-name b').text(texture + ' ' + color);
        $('#previewName').text(texture + ' ' + color);
        $('#previewSub').text(texture + ' ' + color);
        $('.specification-texture-color b').text(color);

        // get background color (RGB)
        let rgb = $('.colour-button:checked')
            .next('label')
            .css('background-color');

        // convert to HEX
        let hex = rgbToHex(rgb);

        $('.specification-texture-hexa-code b').text(hex);
        $('.specification-texture-colour-code').css('background-color', hex);
    }

    // run on load
    updateText();

    // update on click
    $(document).on('click', '.texture-button, .colour-button', function () {
        setTimeout(updateText, 1200);
    });

});


// popup and pdf download logic

document.addEventListener("DOMContentLoaded", function () {
    let currentPopup = null;
    let isDownloading = false;

    // Helper function to set the active popup safely and RESET old success messages
    function setActivePopup(popup) {
        currentPopup = popup;
        
        // RESET STATE: Hide any old thank-you messages from previous submissions
        if (popup) {
            const oldSuccessMsg = popup.querySelector(".message.success");
            if (oldSuccessMsg) {
                oldSuccessMsg.style.display = "none";
                // If Globo uses a wrapper class, hide it too
                const parentMsg = oldSuccessMsg.closest('.globo-form-success, .message-container');
                if (parentMsg) parentMsg.style.display = "none";
            }
        }

        if (popup && !popup.dataset.observerAttached) {
            trackFormSuccess(popup);
            popup.dataset.observerAttached = "true";
        }
    }

    // OPEN POPUP (Manual Click)
    document.addEventListener("click", function (e) {     
        const btn = e.target.closest(".popup-btn");
        if (!btn) return;
        e.preventDefault();
        
        const popupId = btn.getAttribute("data-popup");
        const popup = document.getElementById(popupId);
        
        if (!popup) return;
        
        setActivePopup(popup); // This now completely clears the old success screen!
        popup.classList.add("active");
        document.body.classList.add("popup-open");
        
        // Product title logic
        const productTitle = btn.dataset.productTitle;
        if (productTitle) {
            let attempts = 0;
            const checkFormLoaded = setInterval(function () {
                attempts++;
                
                const hiddenInput = popup.querySelector(
                    '.globo-formbuilder-element input[type="hidden"], .globo-formbuilder input[type="hidden"], input[data-name="hidden"]'
                );
                
                if (hiddenInput) {
                    hiddenInput.value = productTitle;
                    hiddenInput.setAttribute("value", productTitle);

                    hiddenInput.dispatchEvent(new Event("input", { bubbles: true }));
                    hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));

                    clearInterval(checkFormLoaded);
                }

                if (attempts > 40) {
                    clearInterval(checkFormLoaded);
                }
            }, 100);
        }
    });

    // CLOSE POPUP
    document.querySelectorAll(".popup-close, .popup-overlay").forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.preventDefault();

            const popup = this.closest(".custom-popup");
            if (popup) {
                popup.classList.remove("active");
            }

            if (document.querySelectorAll(".custom-popup.active").length === 0) {
                document.body.classList.remove("popup-open");
            }
        });
    });

    // DOWNLOAD PDF
    function triggerDownload(popupElement) {
        const activePopup = popupElement || currentPopup; 
        if (!activePopup) return;
        if (activePopup.id === "expert-popup") return;

        if (isDownloading) return; 
        isDownloading = true;

        const pdfUrl = activePopup.getAttribute("data-pdf");
        if (!pdfUrl) {
            isDownloading = false;
            return;
        }

        fetch(pdfUrl)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.blob();
            })
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;

                if (activePopup.id === "tds-popup") {
                    link.download = "TDS.pdf";
                } else if (activePopup.id === "bim-popup") {
                    link.download = "BIM-STL.pdf";
                } else if (activePopup.id === "catalogue-popup") {
                    link.download = "Catalogue.pdf";
                } else {
                    link.download = "download.pdf";
                }

                document.body.appendChild(link);
                link.click();
                
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);

                setTimeout(function() {
                    isDownloading = false; 
                    activePopup.classList.remove("active");
                    if (document.querySelectorAll(".custom-popup.active").length === 0) {
                        document.body.classList.remove("popup-open");
                    }
                }, 500);
            })
            .catch(error => {
                console.error("Download failed:", error);
                window.open(pdfUrl, '_blank');
                isDownloading = false;
            });
    }

    // FORM SUCCESS TRACKING
    function trackFormSuccess(popupElement) {
        const formContainer = popupElement.querySelector(".globo-form-app");
        if (!formContainer) return;

        // Reset thank you screen if user starts typing in any field manually
        formContainer.addEventListener('input', function() {
            const successMsg = formContainer.querySelector(".message.success");
            if (successMsg) successMsg.style.display = "none";
        });

        const observer = new MutationObserver(function(mutations) {
            // Filter to see if the mutation actually caused a success message visibility toggle
            let statusChanged = false;
            for (let mutation of mutations) {
                if (mutation.type === "attributes" || mutation.type === "childList") {
                    statusChanged = true;
                    break;
                }
            }
            if (!statusChanged) return;

            // Strict Validation Check: Stop completely if error messages or classes are visible
            const containerText = formContainer.innerText || "";
            if (containerText.includes("is required") || containerText.includes("invalid")) {
                return; 
            }

            const hasErrorClasses = formContainer.querySelector(".globo-error, .invalid, .error-message, .globo-form-error, .globo-formbuilder-error");
            if (hasErrorClasses) {
                return;
            }

            const successMsg = formContainer.querySelector(".message.success");
            
            if (
                successMsg &&
                !isDownloading &&
                (successMsg.style.display === "block" || getComputedStyle(successMsg).display !== "none")
            ) {
                // Double check no fields are marked invalid right now
                const hasInvalidInputs = formContainer.querySelector('input.invalid, input[aria-invalid="true"]');
                if (hasInvalidInputs) return;

                console.log("Verified fresh success criteria. Initializing download.");
                triggerDownload(popupElement);
            }
        });

        observer.observe(formContainer, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    // CAPTURE INTENT BEFORE REDIRECT
    document.querySelectorAll('.auth-trigger-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            const triggerType = this.getAttribute('data-login-trigger');
            if (triggerType) {
                sessionStorage.setItem('pending_auth_trigger', triggerType);
            }
        });
    });

    // AUTO OPEN AFTER LOGIN
    const savedTrigger = sessionStorage.getItem('pending_auth_trigger');
    if (savedTrigger) {
        let targetButton = null;

        if (savedTrigger === "tds") targetButton = document.getElementById("tds-btn-native");
        if (savedTrigger === "bim") targetButton = document.getElementById("bim-btn-native");
        if (savedTrigger === "catalogue") targetButton = document.getElementById("catalogue-btn-native");
        
        if (targetButton) {
            setTimeout(function() {
                const popupId = targetButton.getAttribute("data-popup");
                const targetPopup = document.getElementById(popupId);
                if (targetPopup) {
                    setActivePopup(targetPopup);
                }
                
                targetButton.click();
                sessionStorage.removeItem('pending_auth_trigger');
            }, 1000); 
        } else {
            sessionStorage.removeItem('pending_auth_trigger');
        }
    }
});

// API FAQ

document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".custom-faq-item");

    items.forEach(function (item) {

        const question = item.querySelector(".custom-faq-question");

        question.addEventListener("click", function () {

            // Close all other FAQs
            items.forEach(function (otherItem) {

                if (otherItem !== item) {
                    otherItem.classList.remove("active");

                    otherItem.querySelector(".custom-faq-answer").style.display = "none";
                    otherItem.querySelector(".custom-faq-icon").innerHTML = "+";
                }

            });

            const answer = item.querySelector(".custom-faq-answer");
            const icon = item.querySelector(".custom-faq-icon");

            // Toggle current FAQ
            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                answer.style.display = "block";
                icon.innerHTML = "−";
            } else {
                answer.style.display = "none";
                icon.innerHTML = "+";
            }

        });

    });

});

//Product Variant Validation
document.addEventListener('DOMContentLoaded', function () {

  const isProductPage = window.location.pathname.includes('/products/');
  if (!isProductPage) return;

  if (window.location.search.includes('variant=')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url.toString());
  }

  const hasColorOption = document.querySelectorAll('input[name="Color"]').length > 0;
  const hasFinishingOption = document.querySelectorAll('input[type="radio"].texture-button').length > 0;

  if (!hasColorOption && !hasFinishingOption) return;

  function setSpanNormal(span, text) {
    if (!span) return;
    span.textContent = text;
    span.style.color = 'inherit';
    span.style.fontSize = 'inherit';
    span.style.fontWeight = 'inherit';
  }

  function setSpanError(span, text) {
    if (!span) return;
    span.textContent = text;
    span.style.color = 'red';
    span.style.fontWeight = '500';
    span.style.fontSize = '13px';
  }

  function uncheckAll() {
    document.querySelectorAll('input[name="Color"], input[type="radio"].texture-button').forEach(function (r) {
      r.checked = false;
      r.removeAttribute('checked');
    });

    const cs = document.querySelector('#selected-Color');
    const fs = document.querySelector('#selected-Finishing');

    if (cs) {
      cs.textContent = '';
      cs.style.cssText = '';
    }

    if (fs) {
      fs.textContent = '';
      fs.style.cssText = '';
    }
  }

  uncheckAll();
  setTimeout(uncheckAll, 50);
  setTimeout(uncheckAll, 150);

  let lastColor = '';
  let lastFinishing = '';
  let isReady = false;

  setTimeout(function () {
    uncheckAll();
    isReady = true;
  }, 350);

  document.addEventListener('click', function (e) {

    if (!isReady) return;

    const label = e.target.closest('label[data-color], label[data-Color]');
    if (!label) return;

    const colorVal = label.getAttribute('data-color') || label.getAttribute('data-Color');
    if (!colorVal) return;

    lastColor = colorVal;

    const colorSpan = document.querySelector('#selected-Color');
    setSpanNormal(colorSpan, ' ' + lastColor);

    // Prevent auto-select finishing
    setTimeout(function () {

      if (!lastFinishing) {

        document.querySelectorAll('input[type="radio"].texture-button').forEach(function (r) {
          r.checked = false;
          r.removeAttribute('checked');
        });

        const fs = document.querySelector('#selected-Finishing');

        if (fs) {
          fs.textContent = '';
          fs.style.cssText = '';
        }
      }

    }, 100);

  });

  document.addEventListener('change', function (e) {

    if (!isReady) return;

    if (e.target.matches('input[type="radio"].texture-button')) {
      lastFinishing = e.target.value;
      const finishingSpan = document.querySelector('#selected-Finishing');
      setSpanNormal(finishingSpan, ' ' + lastFinishing);
    }

    if (e.target.matches('input[name="Color"]')) {
      lastColor = e.target.value;
      const colorSpan = document.querySelector('#selected-Color');
      setSpanNormal(colorSpan, ' ' + lastColor);
    }

  });

  const productForm = document.querySelector('.product');

  if (productForm) {

    const observer = new MutationObserver(function () {

      if (!isReady) return;
      const autoCheckedColor = document.querySelector('input[name="Color"]:checked');
      if (autoCheckedColor && !lastColor) {
        lastColor = autoCheckedColor.value;
      }

      const autoCheckedFinishing = document.querySelector('input[type="radio"].texture-button:checked');
      if (autoCheckedFinishing && !lastFinishing) {
        lastFinishing = autoCheckedFinishing.value;
      }
      if (lastColor) {
        const cs = document.querySelector('#selected-Color');
        if (
          cs &&
          cs.style.color !== 'red' &&
          (cs.textContent.trim() === '' || cs.textContent.trim() === 'Please select')
        ) {
          setSpanNormal(cs, ' ' + lastColor);
        }
      }
      if (lastFinishing) {
        const fs = document.querySelector('#selected-Finishing');

        if (
          fs &&
          fs.style.color !== 'red' &&
          (fs.textContent.trim() === '' || fs.textContent.trim() === 'Please select')
        ) {
          setSpanNormal(fs, ' ' + lastFinishing);
        }
      }
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'class']
    });
  }

  function validateSelections(e) {

    let allSelected = true;
    let elementToScrollTo = null;

    if (hasColorOption) {

      const colorChecked = document.querySelector('input[name="Color"]:checked');
      const colorSpan = document.querySelector('#selected-Color');

      if (!colorChecked) {
        allSelected = false;
        setSpanError(colorSpan, ' Please select');
      } else {
        setSpanNormal(colorSpan, ' ' + colorChecked.value);
      }
    }

    if (hasFinishingOption) {

      const finishingChecked = document.querySelector('input[type="radio"].texture-button:checked');
      const finishingSpan = document.querySelector('#selected-Finishing');

      if (!finishingChecked) {
        allSelected = false;
        setSpanError(finishingSpan, ' Please select');
        if (!elementToScrollTo) {
          elementToScrollTo = document.querySelectorAll('input[type="radio"].texture-button')[0] || finishingSpan;
        }
      } else {
        setSpanNormal(finishingSpan, ' ' + finishingChecked.value);
      }
    }

    if (!allSelected) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      if (elementToScrollTo) {
        elementToScrollTo.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return false;
    }
  }

  setTimeout(function () {

    const addToCartBtn = document.querySelector('[name="add"]');

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', validateSelections, true);
    }

    // Sticky Bar Add To Cart Button (Targeting the clean form setup)
    const stickyForm = document.getElementById('sticky-product-form');
    if (stickyForm) {
      const stickyBtn = stickyForm.querySelector('button[name="add"]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', validateSelections, true);
      }
    }

    // Buy Now & Checkout Buttons
    document.querySelectorAll(
      '.shopify-payment-button button, [id*="buy-now"], [data-testid="Checkout-button"]'
    ).forEach(function (btn) {
      btn.addEventListener('click', validateSelections, true);
    });

  }, 800);

});


// Product MOQ

document.addEventListener('DOMContentLoaded', () => {
  
  function checkAndForceMoq() {
    const variantIdInput = document.querySelector('.product-variant-id, [name="id"]');
    const qtyInput = document.querySelector('.quantity__input');
    
    if (!qtyInput || !variantIdInput || !variantIdInput.value) return;

    const sectionId = variantIdInput.closest('[data-section]')?.getAttribute('data-section') || document.querySelector('[id^="VariantMinimumQty-"]')?.id?.split('-')[1];
    const minQtyDataElement = document.getElementById(`VariantMinimumQty-${sectionId}`);
    const priceJsonEl = document.getElementById(`VariantPricesJson-${sectionId}`);
    
    let minQty = 1;
    let currentPrice = 1;

    if (priceJsonEl) {
      const priceMap = JSON.parse(priceJsonEl.textContent);
      currentPrice = priceMap[variantIdInput.value];
    }

    if (currentPrice === 0) {
      qtyInput.value = "1";
      qtyInput.min = "1";
      qtyInput.setAttribute('min', "1");
      qtyInput.dataset.min = "1";
      return; 
    }

    if (minQtyDataElement) {
      const minQtyData = JSON.parse(minQtyDataElement.textContent);
      const currentVariantId = variantIdInput.value;
      const variantMOQ = parseInt(minQtyData[currentVariantId]);
      
      minQty = !isNaN(variantMOQ) ? variantMOQ : 1;
    }

    qtyInput.min = minQty;
    qtyInput.setAttribute('min', minQty);
    qtyInput.dataset.min = minQty;

    if (parseInt(qtyInput.value) < minQty || isNaN(parseInt(qtyInput.value))) {
      qtyInput.value = minQty;
    }
  }

  setTimeout(checkAndForceMoq, 300);

  document.body.addEventListener('change', (event) => {
    if (event.target.matches('[name="id"]') || event.target.closest('.variant-radios, .variant-selects, select[id^="Option"]')) {
      setTimeout(checkAndForceMoq, 50);
      setTimeout(checkAndForceMoq, 150);
      setTimeout(checkAndForceMoq, 300);
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  // Listen for variant selector modifications
  document.body.addEventListener('change', (event) => {
    if (event.target.matches('[name="id"]') || event.target.closest('.variant-radios, .variant-selects, select[id^="Option"]')) {
      setTimeout(() => {
        const variantIdInput = document.querySelector('.product-variant-id, [name="id"]');
        const sectionId = variantIdInput?.closest('[data-section]')?.getAttribute('data-section') || document.querySelector('[id^="VariantPricesJson-"]')?.id?.split('-')[1];
        
        if (!variantIdInput || !sectionId) return;

        const priceJsonEl = document.getElementById(`VariantPricesJson-${sectionId}`);
        if (!priceJsonEl) return;

        const priceMap = JSON.parse(priceJsonEl.textContent);
        const currentPrice = priceMap[variantIdInput.value];

        // Stock and UI element selectors
        const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`) || document.querySelector('[name="add"]');
        const isSoldOut = submitButton ? submitButton.hasAttribute('disabled') || submitButton.innerText.includes('Sold out') || submitButton.innerText.includes('Out of stock') : false;

        const standardAtcWrapper = document.querySelector('.standard-atc-btn-wrapper');
        const quoteButtons = document.querySelector('.bulk-quote-container');
        const qtyFormContainer = document.getElementById(`Quantity-Form-${sectionId}`) || document.querySelector('.product-form__input.product-form__quantity');

        // Logic split condition
        if (currentPrice === 0 || isSoldOut) {
          if (standardAtcWrapper) standardAtcWrapper.classList.add('hidden');
          if (quoteButtons) quoteButtons.classList.remove('hidden');
          if (qtyFormContainer) qtyFormContainer.style.setProperty('display', 'none', 'important');
        } else {
          if (standardAtcWrapper) standardAtcWrapper.classList.remove('hidden');
          if (quoteButtons) quoteButtons.classList.add('hidden');
          if (qtyFormContainer) qtyFormContainer.style.display = '';
        }
      }, 150);
    }
  });
});